import { render } from "./unclose.vue?vue&type=template&id=80294886&scoped=true"
import script from "./unclose.vue?vue&type=script&lang=js"
export * from "./unclose.vue?vue&type=script&lang=js"

import "./unclose.vue?vue&type=style&index=0&id=80294886&scoped=true&lang=scss"

import exportComponent from "D:\\project\\2024\\htos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80294886"]])

export default __exports__